import { useUserLocation } from "@/hooks/use-user-location";
import { AdvancedMarker } from "@vis.gl/react-google-maps";
import React from "react";

export const CenterMarker = React.memo(function CenterMarker() {
	const { userLocation } = useUserLocation();

	if (!userLocation) return null;

	return (
		<AdvancedMarker
			position={userLocation}
			zIndex={50} // Higher than regular markers but lower than clicked markers
		>
			<div className="relative w-8 h-8 flex items-center justify-center">
				{/* Outer light blue ring */}
				<div className="absolute w-8 h-8 bg-blue-200 rounded-full opacity-40"></div>

				{/* Middle ring with white border */}
				<div className="absolute w-6 h-6 bg-blue-300 rounded-full opacity-50 animate-pulse"></div>

				{/* Center solid blue dot */}
				<div className="absolute w-4 h-4 bg-blue-600 rounded-full border-2 border-white"></div>
			</div>
		</AdvancedMarker>
	);
});
